export default {
  /*** Ajouter un ref PRK directement dan sle prepanier ******/
  async ajoutPrkInPanier($this){
         

          var initRef = $this.refPrk.replace(/\s/g,'').replace('_','').replace(/\s/g,'').replace(' ','')

           //Si different de PRK ou GGM = message erreur
           var lidic = initRef.substr(0, 3)

           //Si different de PRK ou GGM = message erreur
           if(lidic.toUpperCase() != 'PRK' && lidic.toUpperCase() != 'GGM'){
            return 'erreur no prk no ggm';/*
            $this.refPrk =  'PRK ' + initRef
            initRef = 'PRK' + initRef
            lidic = 'PRK'*/
          }

          $this.refPrk = initRef.substr(0, 3) + " " + initRef.substr(3) 
          /*
           var detectNoSpace = $this.refPrk.substr(0, 4)
           if(detectNoSpace != 'PRK ' && detectNoSpace != 'GGM '){
            $this.refPrk = $this.refPrk.slice(0, 3) + " " + $this.refPrk.slice(3);
            
           }
*/
           //Récupération du LIDIC réel
           
          

          if(lidic.toUpperCase() == 'GGM' || lidic.toUpperCase() == 'PRK'){

          
          

            this.indexTab = Object.keys($this.$store.state.storePrePanier.StoreShowPrePanierListe).length;
            this.id_perso = this.indexTab + '-' + Math.floor(Math.random() * 100000) + 1

            this.ref_encode = $this.$CryptoJS.AES.encrypt($this.refPrk , process.env.VUE_APP_SALT_ENCODE).toString();

            var refDecoupe = "";

            refDecoupe = initRef.substr(3).replace(/\s/g,'').replace('_','')
            // Nombre de fibre

            //Si ce n'est pas un nombre
            if(refDecoupe.substr(0, 2).match(/\d+/) == null){
              return 'erreur ref prk';
            }
            var nbFibre = refDecoupe.substr(0, 2).match(/\d+/)[0]
         
            this.nombreFibre = parseInt(nbFibre)
 
            
            // Suppression du nombre de fibre dans la réf

            refDecoupe = refDecoupe.replace(nbFibre, '')
            //console.log('Nombre fibre : ' + nbFibre)

            // Type de structure

            var structureFibre = refDecoupe.substr(0, 2)
            var requestStructureFibre =  await this.getStructureDetail(structureFibre , $this)

            if(requestStructureFibre.length == 0){
              return 'erreur ref prk';
            }

            this.refStructureData = requestStructureFibre[0]
            this.refStructure = structureFibre
            // Supression de la structure dans la réf


            refDecoupe = refDecoupe.replace( structureFibre , '');
   
              //chaussette
            var typeChaussette = await this.getChausette(this.refStructureData.fk_type_structure.id , $this)
            


            // Type de fibre 
        var codeRefTypeFibre = refDecoupe.substr(0, 2);
        var requestTypeFibre=  await this.getTypeFibre(codeRefTypeFibre , $this)
          //Si pas de structure existante
          if(requestTypeFibre.length == 0){
            return 'erreur ref prk';
          }
        this.typeFibreData = requestTypeFibre[0]

        this.typeFibre = codeRefTypeFibre
        // Supression du type de fibre dans la réf

        refDecoupe = refDecoupe.replace( codeRefTypeFibre , '');
      

// Connecteurs

        // Gauche

        var arrayPossibleConnecteurGauche = []

        arrayPossibleConnecteurGauche.push(refDecoupe.substr(0, 3))
        arrayPossibleConnecteurGauche.push(refDecoupe.substr(0, 2))
        arrayPossibleConnecteurGauche.push(refDecoupe.substr(0, 1))

        var requestCoA =  await this.getConnecteurDetail(arrayPossibleConnecteurGauche , $this)
          //Si pas de structure existante
          if(requestCoA.length == 0){
            return 'erreur ref prk';
          }

        this.codeRefA = requestCoA[0].code_ref
        this.codeRefAData = requestCoA[0]
        refDecoupe = refDecoupe.replace(this.codeRefA, '')

        // Droite

        var arrayPossibleConnecteurDroite = []

        arrayPossibleConnecteurDroite.push(refDecoupe.substr(0, 3))
        arrayPossibleConnecteurDroite.push(refDecoupe.substr(0, 2))
        arrayPossibleConnecteurDroite.push(refDecoupe.substr(0, 1))

        var requestCoB = await this.getConnecteurDetail(arrayPossibleConnecteurDroite , $this)
        //Si pas de structure existante
        if(requestCoB.length == 0){
          return 'erreur ref prk';
        }
        this.codeRefB = requestCoB[0].code_ref
        this.codeRefBData = requestCoB[0]
        //console.log(typeConnecteurDroite)
        refDecoupe = refDecoupe.replace(this.codeRefB, '')

   
        

           /** Euroclass */

        var codeEuroclass = refDecoupe.substr(0, 1)
    
        var typeEuroclass = null
        if(isNaN(codeEuroclass)){
            // Ce n'est pas un nombre
            var euroclass = codeEuroclass
            euroclassRequest = await this.getEuroclassWithCodeRef(euroclass , $this)
            if(euroclassRequest.length == 0){
              return 'erreur ref prk';
            }
            this.euroclass = euroclassRequest[0].nom
            this.euroclassData = euroclassRequest[0]
            refDecoupe = refDecoupe.replace( codeEuroclass , '')
        } else {
            // C'est un nombre
            if(this.refStructure.includes('A') || this.refStructure.includes('P')){
                typeEuroclass = 4
            } else {
                typeEuroclass = 1
            }
            var euroclassRequest = await this.getEuroclassWithPk(typeEuroclass , $this)
              this.euroclass = euroclassRequest[0].nom
              this.euroclassData = euroclassRequest[0]
        }


        this.longueur = refDecoupe.replace(/(?<![\d.])0+\B/g, '');

        //Check longeur max par structure de cable
        if(this.longueur >= this.refStructureData.fk_type_structure.long_max ){
          this.showMessageLongueurMax = true
          return 'erreur longueur max'
        }
        else if(this.longueur < 1){
          return 'erreur longueur min'
        }

        this.referenceCable = await this.getReferenceCable( this, $this)
        //console.log(this.referenceCable);
        var libelle =  'this.refStructureData.fk_type_structure.libelle_structure_' + $this.$store.state.storeUser.lang
      
        var structLang =  eval(libelle);

         /**********************************************************
            * Si c'est une ref PRK
            ********************************************************/
         if( lidic.toUpperCase() == 'PRK'){
            /** Ajout au panier */
            this.obj = {
              pays: $this.$store.state.storeGlobal.StorePays,
              id:this.indexTab,
              id_perso: this.id_perso,
              sessionId: $this.$store.state.storeUser.sessionId,
              connecteur_a: this.codeRefAData.typeCon,
              connecteur_a_diametre: this.refStructureData.gauche.designation,
              type_chaussette: typeChaussette,
              nombre_fibre: this.nombreFibre,
              euroclass: this.euroclass,
              type_fibre: this.typeFibreData.typeFibre,
              reference_cable: this.referenceCable[0].ref.reference,
              qte_stock_cable: this.referenceCable[0].ref.qte_cable,
              longueur: this.longueur,
              connecteur_b: this.codeRefBData.typeCon,
              ref_prk: $this.refPrk , 
              pa_prk: this.ref_encode , 
              type_structure: structLang ,
              etat: true,
              etatLongueur: true,
              refGerree: false , 
              doc_paths: {
                "fiche-technique": process.env.VUE_APP_URL_API + "/pdf/" + ($this.refPrk.replace(" ", "_")) + "_" + this.id_perso + ".pdf",
              }

            };

  $this.$store.commit('ADD_PRE_PANIER_LISTE', this.obj )

  /** Récupération du prix palier */
  await this.getPrixPalierPrk(this , $this);


         }
          /**********************************************************
            * Si c'est une ref GGM
            ********************************************************/
         if( lidic.toUpperCase() == 'GGM'){
          /** Ajout au panier */
          
           /** Récupération du prix palier */
      const checkRefGeree = await this.checkRefGerreeExist( $this );
      if(checkRefGeree == false){
        //alert(checkRefGeree)
        return 'transformation prk'
      }
  
//alert(resultRefGeree)

          this.obj = {
            pays: $this.$store.state.storeGlobal.StorePays,
            id:this.indexTab,
            id_perso: this.id_perso,
            sessionId: $this.$store.state.storeUser.sessionId,
            connecteur_a: this.codeRefAData.typeCon,
            connecteur_a_diametre: this.refStructureData.gauche.designation,
            type_chaussette: typeChaussette,
            nombre_fibre: this.nombreFibre,
            euroclass: this.euroclass,
            type_fibre: this.typeFibreData.typeFibre,
            reference_cable: this.referenceCable[0].ref.reference,
            qte_stock_cable: this.referenceCable[0].ref.qte_cable,
            longueur: parseInt(this.longueur),
            connecteur_b: this.codeRefBData.typeCon,
            ref_prk: $this.refPrk , 
            pa_prk: this.ref_encode , 
            type_structure: structLang ,
            etat: true,
            etatLongueur: true,
            refGerree: true , 
            doc_paths: {
              "fiche-technique": process.env.VUE_APP_URL_API + "/pdf/" + ($this.refPrk.replace(" ", "_")) + "_" + this.id_perso + ".pdf",
            }

          };

$this.$store.commit('ADD_PRE_PANIER_LISTE', this.obj )

await this.getPrixPalierRefGerree(this , $this , this.id_perso , $this.refPrk ); 

         }
         
      }
      else{
        return 'erreur prk';
      }
  },


  
  async getReferenceCable(requestThis , $this) {   
    try {
      const reponse = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/preco_refs?' +
      'fk_nb_fibre.nb_fibre='+ requestThis.nombreFibre +
      '&fk_type_fibre='+ requestThis.typeFibreData.pkTypeFibre +
      '&fk_pays.nom='+$this.$store.state.storeGlobal.StorePays +
      "&fk_euroclass="+ requestThis.euroclassData.id +
      '&fk_env_web.nom='+ $this.$store.state.storeGlobal.StoreEnvWeb +
      '&fk_env.nom='+ $this.$store.state.storeGlobal.StoreEnv +
      '&fk_structure='+ requestThis.refStructureData.fk_type_structure.id
      ,{
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        headers: {
        "Accept": "application/json",
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
      },
      })
      if (!reponse.ok) {
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        const json = await reponse.json();
        return json;
      }
      catch(error) {
        console.error(`Impossible d'obtenir les produits : ${error}`);
      }
  },


    async getTypeFibre(codeTypeFibre , $this){
      try {
    const reponse = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/preco_type_fibres?code_ref='+ codeTypeFibre ,{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
    },
    }) 
            if (!reponse.ok) {
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        const json = await reponse.json();
        return json;
      }
      catch(error) {
        console.error(`Impossible d'obtenir les produits : ${error}`);
      }
          },
    async getStructureDetail(codeRefStructure , $this){
      try {
    const reponse = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/preco_structure_refs?code_ref='+ codeRefStructure ,{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization":  $this.$store.state.storeGlobal.StoreJwtToken
    },
    }) 
            if (!reponse.ok) {
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        const json = await reponse.json();
        return json;
      }
      catch(error) {
        console.error(`Impossible d'obtenir les produits : ${error}`);
      }
          },

    async getConnecteurDetail(arrayPossibleConnecteur , $this){
      try {
    const reponse = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/preco_cons?code_ref%5B%5D='+ arrayPossibleConnecteur[0]  +'&code_ref%5B%5D='+ arrayPossibleConnecteur[1]  +'&code_ref%5B%5D='+ arrayPossibleConnecteur[2] ,{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
    },
    }) 
            if (!reponse.ok) {
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        const json = await reponse.json();
        return json;
      }
      catch(error) {
        console.error(`Impossible d'obtenir les produits : ${error}`);
      }
          },
       
          async getChausette(  pkStructure , $this) {
            try {
              //Appel de l'api + transofrmation Json'
              const res = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/preco_chaussette_imgs?' +
            'chaussettes='+ pkStructure ,{
              method: "GET", // *GET, POST, PUT, DELETE, etc.
              headers: {
              "Accept": "application/json",
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
            },
            }
           )
              var resultApi = (await res.json());
              //var chaussette = resultApi[0];
            return resultApi[0].chaussette
              //this.LoadChaussette = true;
            } catch (error) {
              this.answer = 'Error! Could not reach the API. ' + error
            }
          },


          async getEuroclassWithCodeRef(codeRefEuroclass , $this){
      try {
    const reponse = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/euroclasses?code_ref='+ codeRefEuroclass ,{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
    },
    }) 
            if (!reponse.ok) {
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        const json = await reponse.json();
        return json;
      }
      catch(error) {
        console.error(`Impossible d'obtenir les produits : ${error}`);
      }
          },


          async getEuroclassWithPk(pkEuroclass , $this){
      try {
    const reponse = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/euroclasses?id='+ pkEuroclass ,{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
    },
    }) 
            if (!reponse.ok) {
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        const json = await reponse.json();
        return json;
      }
      catch(error) {
        console.error(`Impossible d'obtenir les produits : ${error}`);
      }
          },


      async getPrixPalierPrk(requestThis, $this){
        
        try {
    const reponse = await fetch(
      $this.$store.state.storeGlobal.StoreApi + '/api/price/webshop' , {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
          },
          body: JSON.stringify({ 
            coa : requestThis.codeRefAData.codeRef ,
            cob : requestThis.codeRefBData.codeRef ,
            nbfibre : requestThis.nombreFibre ,
            refcable : requestThis.referenceCable[0].ref.reference ,
            longueurcable : requestThis.longueur,
            typefibre : requestThis.typeFibreData.codeRef,
            typestructure : requestThis.refStructure ,
            pays : $this.$store.state.storeGlobal.StorePays
          })
         } ) 
            if (!reponse.ok) {
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        const json = await reponse.json();

         /** Depassement du dernier prix palier */
        if( $this.$store.state.storeGlobal.StoreEnvWeb == "Webshop" 
        && $this.$CryptoJS.AES.decrypt(json.ref_palier, process.env.VUE_APP_SALT_ENCODE).toString($this.$CryptoJS.enc.Utf8) == 'GGM PRET0790'
        ){
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        else if( ($this.$store.state.storeGlobal.StoreEnvWeb == "CustomerCare GIGAMEDIA" 
        || $this.$store.state.storeGlobal.StoreEnvWeb == "Site Gigamedia" 
         ) && $this.$CryptoJS.AES.decrypt(json.ref_palier, process.env.VUE_APP_SALT_ENCODE).toString($this.$CryptoJS.enc.Utf8) == 'GGM PRET0790'){
          var prixTotDecode = $this.$CryptoJS.AES.decrypt(json.prix_tot, process.env.VUE_APP_SALT_ENCODE).toString($this.$CryptoJS.enc.Utf8)
          var prixTotDecodeArround = Math.round((parseFloat(prixTotDecode ) + Number.EPSILON) * 100) / 100;

          json.prix_net_palier = $this.$CryptoJS.AES.encrypt( prixTotDecodeArround.toString()  , process.env.VUE_APP_SALT_ENCODE).toString();
        }
         
       // 
    

        /** prix webshop */ 
        if($this.$store.state.storeGlobal.StorePays == 'NL'){
          $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'custom_ref_nl' , json.custom_ref_nl );
        }
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'palier' , json.palier );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'ref_palier' , json.ref_palier );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'libelle_palier' , json.libelle_palierrequestThis);
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'prix_net_palier' , json.prix_net_palier );
        /** prix custmer requestThis **/
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'prix_cable_km' , json.prix_cable_km );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'prix_cable' , json.prix_cable );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'prix_connecteur' , json.prix_connecteur );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'prix_tot' , json.prix_tot );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'prix_tot_arround' , json.prix_tot_arround );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'ref_co' , json.ref_co );
        const item = $this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso === requestThis.id_perso);
        $this.globalFunction.logConfiguration($this, item)
        $this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', requestThis.id_perso)
 
      }
      catch(error) {
        // console.error(`Impossible d'obtenir les produits : ${error}`);
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'erreur_prix' , true );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'libelle_palier' , 'Erreur' );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'ref_palier' , false );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'prix_net_palier' , false );
        $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'palier' , 'Erreur' );
        $this.globalFunction.MajLignePrePanierNoPa($this, requestThis.id_perso , 'etat' , false );
        const item = $this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso === requestThis.id_perso);
        $this.globalFunction.logConfiguration($this, item)
        $this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', requestThis.id_perso)
      }

    },


    async checkRefGerreeExist($this){
            try {
              const reponse = await fetch(
                $this.$store.state.storeGlobal.StoreApi + '/api/price/refgereeonref', {
                    method: "POST",
                    headers: {
                      "Accept": "application/json",
                      "Content-Type": "application/json; charset=utf-8",
                      "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
                    },
                    body: JSON.stringify({ 
                      reference : $this.refPrk,
                      pays: $this.$store.state.storeGlobal.StorePays
                    })
                   } ) 
                      if (!reponse.ok) {
                    throw new Error(`Erreur HTTP : ${reponse.status}`);
                  }
      
                  const json = await reponse.json();
                  if(Object.keys(json).length === 0){
                    return false;
                  }
                }catch(error) {
                 console.log(error)
                }},

    async getPrixPalierRefGerree(requestThis , $this, id_perso , reference){
      try {
        const reponse = await fetch(
          $this.$store.state.storeGlobal.StoreApi + '/api/price/refgereeonref', {
              method: "POST",
              headers: {
                "Accept": "application/json",
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
              },
              body: JSON.stringify({ 
                reference : reference,
                pays: $this.$store.state.storeGlobal.StorePays
              })
             } ) 
                if (!reponse.ok) {
              throw new Error(`Erreur HTTP : ${reponse.status}`);
            }

            const json = await reponse.json();
             
       // Utilisation du prix lpfr de la ref gerree au lieu de la ref palier 
    var price_ref_geree_decrypt = $this.$CryptoJS.AES.decrypt(json.prix_ref_geree, process.env.VUE_APP_SALT_ENCODE).toString($this.$CryptoJS.enc.Utf8) * 0.45
    var price_ref_geree_arround_decrypt = Math.round(price_ref_geree_decrypt * 100) / 100

  
    var price_ref_geree = $this.$CryptoJS.AES.encrypt( price_ref_geree_decrypt.toString()  , process.env.VUE_APP_SALT_ENCODE).toString();
    var price_ref_geree_arround = $this.$CryptoJS.AES.encrypt( price_ref_geree_arround_decrypt.toString()  , process.env.VUE_APP_SALT_ENCODE).toString();

    $this.globalFunction.MajLignePrePanierNoPa($this, id_perso , 'ref_structure' , 'SLSOH' );
    $this.globalFunction.MajLignePrePanierNoPa($this, id_perso , 'ean' , json.ean );

        //TODO prix net cable ??
         /** prix webshop */
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'palier' , json.reference );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'libelle_palier' , json.description );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_palier' , price_ref_geree_arround );
         // $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_palier' , json.reference );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_net_palier' , price_ref_geree_arround );

          /** prix custmer ***/
       
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_cable_km' , price_ref_geree_arround );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_cable' , price_ref_geree_arround );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_connecteur' , price_ref_geree_arround );
       
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_tot' , price_ref_geree );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'prix_tot_arround' , price_ref_geree_arround );
          $this.globalFunction.MajLignePrePanier($this, id_perso , 'ref_co' , $this.$CryptoJS.AES.encrypt( json.ref_search.toString()  , process.env.VUE_APP_SALT_ENCODE).toString());
      
          const item = $this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso === id_perso);
          $this.globalFunction.logConfiguration($this, item)
          $this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', id_perso)

    }
    catch(error) {
      // console.error(`Impossible d'obtenir les produits : ${error}`);
      $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'erreur_prix' , true );
      $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'libelle_palier' , 'Erreur' );
      $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'ref_palier' , false );
      $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'prix_net_palier' , false );
      $this.globalFunction.MajLignePrePanier($this, requestThis.id_perso , 'palier' , 'Erreur' );
      $this.globalFunction.MajLignePrePanierNoPa($this, requestThis.id_perso , 'etat' , false );
      const item = $this.$store.state.storePrePanier.StoreShowPrePanierListe.find(item => item.id_perso === requestThis.id_perso);
      $this.globalFunction.logConfiguration($this, item)
      $this.$store.commit('ADD_FICHE_TECHNIQUE_STATUS', requestThis.id_perso)
    }},

    async getReferenceIntoDevis(devis, versionDevis , $this) {   
      try {
        const reponse = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/configurations?' +
        'fk_devis='+ devis +
        '&devis_version='+ versionDevis 
        ,{
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
        },
        }
        )
        if (!reponse.ok) {
            throw new Error(`Erreur HTTP : ${reponse.status}`);
          }
          const json = await reponse.json();
          return json;
        }
        catch(error) {
          console.error(`Impossible d'obtenir les produits : ${error}`);
        }
    },
    async getReferenceIntoSession( numeroSession , $this) {   
      // trim pour supprimer les espaces
      numeroSession = numeroSession.trim();
      try {
        const reponse = await fetch($this.$store.state.storeGlobal.StoreApi + '/api/configuration_session?' +
        'info='+ numeroSession ,{
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": $this.$store.state.storeGlobal.StoreJwtToken
        },
        }
        )
        if (!reponse.ok) {
            throw new Error(`Erreur HTTP : ${reponse.status}`);
          }
          const json = await reponse.json();
          return json;
        }
        catch(error) {
          console.error(`Impossible d'obtenir les produits : ${error}`);
        }
    },

  
}